import {Component, ElementRef, EventEmitter, inject, Input, OnChanges, Output} from '@angular/core';
import {AConst} from '../../core/a-const.enum';
import {ContentMenu} from '../../core/definitions/object-content-tab/content-menus';

@Component({
    selector: 'app-object-content-dropdown-tab',
    templateUrl: './object-content-dropdown-tab.component.html',
    styleUrls: ['./object-content-dropdown-tab.component.scss'],
    standalone: false
})
export class ObjectContentDropdownTabComponent implements OnChanges {
  // Injections
  private readonly dropdownTabElementRef: ElementRef = inject(ElementRef);

  @Input() menu: ContentMenu;
  @Input() isEditing: boolean;
  @Output() menuOpened = new EventEmitter();

  AConst = AConst;
  private dropdownTabItem;

  ngOnChanges() {
    this.dropdownTabItem = this.dropdownTabElementRef.nativeElement;
  }

  openMenu() {
    this.menuOpened.emit(this.menu);
  }

  getDropdownTabElement() {
    return this.dropdownTabElementRef.nativeElement;
  }

}
